import React from 'react';
import posts from "../data/posts";
import {Link} from "react-router-dom";

function BlogList() {

    return (
        <div>
            <div className="jumbotron graph-back d-flex align-items-center">
                <h1 className="display-3 mt-5">Posts</h1>

            </div>

            <div className={"container-fluid"}>
                <ul>
                    {posts.map(value => (
                        <li key={value.key}>
                            <Link to={`/blog/${value.key}`}>
                                    {value.date} - {value.title}
                            </Link>
                        </li>))}
                </ul>
            </div>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
        </div>
    )
}

export default BlogList;